import Model from "./Model";

export default class FichaIndividualAee extends Model {
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
